<swiper-container #swiperContainer class="strategy-intro-swiper" [modules]="swiperModules" [freeMode]="false" [pagination]="true">
  @for (slide of slides; track slide) {
    <swiper-slide>
      <div class="slide-content">
        <div class="slide-image-container" [ngClass]="{ 'align-right': slide.alignImageRight }">
          <img [src]="slide.imageSrc" [alt]="slide.imageAlt" />
        </div>
        <div class="slide-text-container">
          <h1 class="ds-title-1 header">{{ slide.heading | translate }}</h1>
          <p class="ds-running-1">
            {{ slide.paragraph | translate }}
          </p>
        </div>
      </div>
    </swiper-slide>
  }
</swiper-container>

<app-footer class="strategy-intro-footer">
  @if (currentSlideIndex < 2) {
    <button class="ui-button" (click)="goToNextSlide()">{{ 'investIntro.slide1.cta' | translate }}</button>
  } @else {
    <button class="ui-button" (click)="proceedToNextQLStep()">
      <span class="icon-i-windmill"></span>
      {{ 'investIntro.slide3.cta' | translate }}
    </button>
  }
</app-footer>
